import prepareData from 'scoreboard/charts/chart-data/prepare-data'
import { NUMBER, PERCENT } from 'scoreboard/datasets/model/data-type'

/**
 * For the given chart and axis, returns the data type
 *
 * @param {ChartDesigner} chart
 * @param {'left|'right'} axis
 *
 * @return {PERCENT|NUMBER}
 */
function getAxisDataType ({ chart, axis }) {
	// The rules for whether the axis is displayed in a regular number or
	// percentage are pretty complicated. The easiest way to figure it out is
	// just to prepare the data and see how the axis is being formatted
	let prepared = prepareData({
		chart,
		chartData: chart.data
	})

	let formatter = prepared.axes[axis].formatter
	if (!formatter) {
		return NUMBER
	}

	// If there's a % sign in the formatted value, then it's a percent;
	// otherwise, just treat it as a regular number
	return formatter(1).indexOf('%') !== -1 ? PERCENT : NUMBER
}

export default getAxisDataType

getAxisDataType.__filename__ = 'charts/edit/analytics/get-axis-data-type.js'
